import * as yup from 'yup';

export const initialValues = {
	id: null,
	degree: '',
	status: '',
	course: '',
	courseDescription: '',
	institution: '',
	endYear: '',
	startYear: '',
};

const schema = yup.object().shape({
	degree: yup.string().required('Formação Acadêmica é obrigatório!'),
	status: yup.string().required('Situação é obrigatório!'),
	course: yup.string().when('degree', {
		is: val => !['Ensino Fundamental', 'Ensino Médio', 'Ensino Especial'].includes(val),
		then: schema => schema.required('Curso é obrigatório!'),
		otherwise: schema => schema,
	}),
	courseDescription: yup.string().when('degree', {
		is: val => ['Pós-Graduação', 'Mestrado', 'Doutorado'].includes(val),
		then: schema => schema.required('Descrição do curso é obrigatório!'),
		otherwise: schema => schema.when('course', {
			is: val => ['Outro'].includes(val),
			then: schema => schema.required('Descrição do curso é obrigatório!'),
			otherwise: schema => schema,
		}),
	}),
	institution: yup.string(),
	startYear: yup
		.number()
		.typeError('Data de início deve ser um número de 4 dígitos. Ex.: 2005')
		.min(1900, 'Data de início deve ser maior que 1900')
		.when('degree', {
			is: val => !['Ensino Fundamental', 'Ensino Médio', 'Ensino Especial'].includes(val),
			then: schema => schema.required('Data de início é obrigatório!'),
			otherwise: schema => schema.nullable(),
		}),
	endYear: yup
		.number()
		.moreThan(yup.ref('startYear'), 'Data de término deve ser maior que a data de início')
		.typeError('Data de término deve ser um número de 4 dígitos. Ex.: 2005')
		.when('degree', {
			is: val => !['Ensino Fundamental', 'Ensino Médio', 'Ensino Especial'].includes(val),
			then: schema => schema.when('status', {
				is: val => val === 'Completo',
				then: schema => schema.required('Data de término é obrigatório quando situação é completo!'),
				otherwise: schema => schema,
			}),
			otherwise: schema => schema,
		}),
});

export default schema;
